import { createFeatureSelector, createReducer, on } from '@ngrx/store';
import { TariffManagementActions } from '../actions/tariff-management.actions';

export const tariffManagementFeatureKey = 'tariffManagement';
export const tariffManagementFeatureSelector = createFeatureSelector<TariffManagementState>(tariffManagementFeatureKey);

export interface TariffManagementState {
  tariffListLoading: boolean;
  getZoneCitiesLoading: boolean;
}

export const tariffManagementInitState: TariffManagementState = {
  tariffListLoading: false,
  getZoneCitiesLoading: false,
};

export const reducer = createReducer(
  tariffManagementInitState,
  on(TariffManagementActions.getTariff, (state) => {
    return {
      ...state,
      tariffListLoading: true,
    };
  }),
  on(TariffManagementActions.getTariffSuccess, TariffManagementActions.getTariffFail, (state) => {
    return {
      ...state,
      tariffListLoading: false,
    };
  }),
  on(TariffManagementActions.getZoneCities, (state) => {
    return {
      ...state,
      getZoneCitiesLoading: true,
    };
  }),
  on(TariffManagementActions.getZoneCitiesSuccess, TariffManagementActions.getZoneCitiesFail, (state) => {
    return {
      ...state,
      getZoneCitiesLoading: false,
    };
  })
);
